import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e4bb024"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "modalHeader" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  filter: "scadenza.startDate",
  sort: "scadenza.startDate"
}
const _hoisted_5 = {
  filter: "contactName",
  sort: "contactName"
}
const _hoisted_6 = {
  filter: "name",
  sort: "name"
}
const _hoisted_7 = {
  filter: "scadenza.text",
  sort: "scadenza.text"
}
const _hoisted_8 = {
  filter: "scadenza.status",
  sort: "scadenza.status"
}
const _hoisted_9 = {
  filter: "scadenza.subStatus",
  sort: "scadenza.subStatus"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { colspan: "99" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_comment_text = _resolveComponent("comment-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Attività",
          text: "Attività"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$filters.date(_ctx.date)), 1)
      ])
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.items
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data attività",
                text: "Data attività"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Contatto",
                text: "Contatto"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nome",
                text: "Nome"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Attività",
                text: "Attività"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Stato",
                text: "Stato"
              })
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Sottostato",
                text: "Sottostato"
              })
            ]),
            _hoisted_10
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                _createElementVNode("td", _hoisted_12, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.scadenza.startDate, "YYYY-MM-DD HH:MM")), 1),
              _createElementVNode("td", null, _toDisplayString(item.contactName), 1),
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_comment_text, {
                  comment: item.scadenza
                }, null, 8, ["comment"])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(["label", _ctx.isPast(_ctx.date, item.hour) ? 'da-fare' : 'in-attesa'])
                }, _toDisplayString(_ctx.isPast(_ctx.date, item.hour) ? "Da fare" : "In attesa"), 3)
              ]),
              _createElementVNode("td", null, _toDisplayString(item.scadenza.subStatus), 1),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: ($event: any) => (_ctx.leadModal(item))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Apri",
                    text: "Apri"
                  })
                ], 8, _hoisted_13),
                (item.clienteIdentifier)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary ml-2",
                      onClick: ($event: any) => (_ctx.$router.push('/clienti/detail/' + item.clienteIdentifier))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Scheda cliente",
                        text: "Scheda cliente"
                      })
                    ], 8, _hoisted_14))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ]))
}